module.exports = __webpack_public_path__ + "static/media/unsplash-burbank-sign.a91bfc55.jpg";